import { assertType, DiffContent, Entity, Mutation, TrackingBuilder } from "../base";

class DashboardWidget implements Entity<DashboardWidget> {
    static STORE = "DashboardWidget";
    private _uuid: string;
    private _componentName : string;
    private _config : Record<string, string> = {};

    constructor(uuid:string, componentName:string, config:Record<string, string>) {
        this._uuid = uuid;
        this._componentName = componentName;
        this._config = config;
    }

    builder(): DashboardWidgetBuilder {
        return new DashboardWidgetBuilder(this);
    }

    toJson(): DashboardWidgetJson {
        return {
            uuid: this._uuid,
            componentName: this._componentName,
            config : this._config
        }
    }
    static identityValue = new DashboardWidget("", "", {});
    static identity() {
        return DashboardWidget.identityValue;
    }


    get uuid() { return this._uuid; }
    get componentName() { return this._componentName; }
    get config () { return Object.assign({}, this._config); }
}

interface DashboardWidgetJson {
    uuid: string,
    componentName: string,
    config: Record<string, string>
}

interface DashboardWidgetDiff extends DiffContent<DashboardWidget> {
    uuid?: string,
    componentName?: string,
    config? : Record<string, string>
}

class DashboardWidgetBuilder extends TrackingBuilder<DashboardWidget> {
    private _uuid: string;
    private _componentName: string;
    private _config : Record<string,string>
    protected _diff:DashboardWidgetDiff = {};

    constructor(optionalWidget?:DashboardWidget) {
        super();
        const widget = optionalWidget ? optionalWidget : DashboardWidget.identity();
        this._uuid = widget.uuid;
        this._componentName = widget.componentName;
        this._config = Object.assign({}, widget.config);
    }

    uuid(uuid: string) {
        if(this.isTracking() && this._uuid !== uuid) {
            this._diff.uuid = uuid;
        }
        this._uuid = uuid;
        return this;
    }

    componentName(name: string) {
        if(this.isTracking() && this._componentName !== name) {
            this._diff.componentName = name;
        }
        this._componentName = name;
        return this;
    }
    config(config:Record<string,string>) {
        if(this.isTracking() && JSON.stringify(this._config) !== JSON.stringify(config)) {
            this._diff.config = Object.assign({}, config);
        }
        this._config = Object.assign({}, config);
        return this;
    }
    build(): DashboardWidget {
        return new DashboardWidget(this._uuid, this._componentName, this._config);
    }
    applyDiff(diff: DashboardWidgetDiff): DashboardWidgetBuilder {
        if (diff.uuid) {
            this.uuid(diff.uuid);
        }
        if (diff.componentName) {
            this.componentName(diff.componentName);
        }
        if (diff.config) {
            this.config(diff.config);
        }
        return this;
    }

    applyObj(object: DashboardWidget): DashboardWidgetBuilder {
        this.uuid(object.uuid);
        this.componentName(object.componentName);
        this.config(object.config);
        return this;
    }
    
    getDiff(): DashboardWidgetDiff {
        return this._diff;
    }
}

export { DashboardWidget, DashboardWidgetJson, DashboardWidgetDiff };